import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import { Headline } from "~/features/ui/headline";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";

/**
 * Page title for the downloads overview. The page has no hero, so this also
 * supplies the top spacing that clears the fixed site header (heroes apply the
 * same `--header-height` offset). Without it the filter bar renders under the
 * header with no breathing room.
 */
export function DownloadsHeader(props: {
  title: string;
}) {
  const {
    title
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const {
    isAnnouncementBarVisible
  } = useNavLayout();
  const topSpacing = isAnnouncementBarVisible ? {
    "marginTop": "calc(var(--header-height) + var(--announcement-bar-height))"
  } : {
    "marginTop": "var(--header-height)"
  };
  return <_StyledDiv $_css={[{
    "borderTopWidth": "0px !important"
  }, topSpacing, themeStyle.background, themeStyle.border]}>
      <Wrap mode="light">
        <_StyledDiv2 $_css2={[{
        "paddingLeft": "1.6rem",
        "paddingRight": "1.6rem",
        "paddingTop": "var(--spacing-lg)",
        "paddingBottom": "var(--spacing-lg)",
        "@media (min-width: 1024px)": {
          "borderLeftWidth": "1px",
          "borderRightWidth": "1px",
          "paddingLeft": "4rem",
          "paddingRight": "4rem",
          "paddingTop": "var(--spacing-xl)",
          "paddingBottom": "var(--spacing-xl)"
        }
      }, themeStyle.border]}>
          <_StyledHeadline text={title} />
        </_StyledDiv2>
      </Wrap>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-318rpg-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-318rpg-1"
})`${p => p.$_css2}`;
var _StyledHeadline = /*#__PURE__*/_styled3(Headline).withConfig({
  displayName: "downloads-header___StyledHeadline",
  componentId: "sc-1goxh7-0"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});